/**
 * Barre du bas du téléphone (décision du 17/10/2026) : Accueil, Planning
 * (Ventes sans droit de planning), Créer, un raccourci personnel et Menu (la photo). Le modèle des applications
 * de terrain du marché : la création au pouce, au centre. Une page ouverte
 * depuis le Menu allume l'onglet Menu.
 */
import type { ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { useAuth } from '../../core/auth.js';
import { t } from '../../core/i18n.js';
import { UserAvatar } from '../UserAvatar.js';
import { NavBadge } from '../ui/NavBadge.js';
import { areaMatches, type Area, type BottomBar } from '../../app/areas.js';

function AreaTab({ area, active }: { area: Area | undefined; active: boolean }): ReactNode {
  if (!area) return null;
  const Icon = area.icon;
  return (
    <Link to={area.to} className="bottom-nav__tab" aria-current={active ? 'page' : undefined}>
      <span className="nav-icon">
        <Icon size={22} strokeWidth={2.1} aria-hidden="true" />
        <NavBadge count={area.count} label={area.countLabel ?? ''} />
      </span>
      <span className="bottom-nav__label">{area.label}</span>
    </Link>
  );
}

export function BottomNav(props: { bar: BottomBar; createOpen: boolean; onCreate: () => void }): ReactNode {
  const { me } = useAuth();
  const { pathname } = useLocation();
  const { home, second, shortcut } = props.bar;
  const tabs = [home, second, shortcut];
  const current = tabs.find((area) => area && areaMatches(area, pathname));
  return (
    <nav className="bottom-nav" aria-label={t('nav.navigationPrincipale')}>
      <AreaTab area={home} active={current === home} />
      <AreaTab area={second} active={current === second} />
      <button
        type="button"
        className="bottom-nav__create"
        aria-haspopup="dialog"
        aria-expanded={props.createOpen}
        onClick={(event) => {
          event.currentTarget.focus();
          props.onCreate();
        }}
      >
        <span className="bottom-nav__plus" aria-hidden="true">
          <Plus size={24} strokeWidth={2.4} />
        </span>
        <span className="bottom-nav__label">{t('nav.creer')}</span>
      </button>
      <AreaTab area={shortcut} active={current !== undefined && current === shortcut} />
      {me ? (
        <Link to="/profil" className="bottom-nav__tab bottom-nav__profile" aria-current={current ? undefined : 'page'}>
          <span className="nav-icon">
            <span className="avatar bottom-nav__avatar" aria-hidden="true">
              <UserAvatar fullName={me.full_name} avatarUrl={me.avatar_url} avatarFileId={me.avatar_file_id} bare />
            </span>
            {/* Une rubrique du Menu attend (messages non lus hors de la barre) : un point. */}
            <NavBadge count={props.bar.menuWaiting ? 1 : 0} label={t('nav.menuAttend')} dot />
          </span>
          <span className="bottom-nav__label">{t('nav.profilMobile')}</span>
        </Link>
      ) : null}
    </nav>
  );
}
